export enum MedicineDeliveryEndpoints {
    GetRequestId = "insureds/me/requests/medicine-delivery",
    GetClinics = "clinics/all/medicine-delivery",
    GetActiveRequests = "ux-gestion-delivery-medicamentos/mep/servicio-al-cliente/v1/seguimiento-solicitudes/",
}
